import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteData,
  type DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteError,
  type DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteResponse,
  deletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDelete,
} from '../../generated';

export type DeletePdpImageMutationVariables =
  DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteData['path'];

export type DeletePdpImageMutation = DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteResponse;

export const useDeletePdpImageMutation = <
  TError = DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<DeletePdpImageMutation, TError, DeletePdpImageMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DeletePdpImageMutation, TError, DeletePdpImageMutationVariables, TContext>({
    mutationKey: ['DeletePdpImage'],
    mutationFn: async ({ workspace_id, pdp_id, image_id }: DeletePdpImageMutationVariables) => {
      const { data } = await deletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDelete({
        path: { workspace_id, pdp_id, image_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useDeletePdpImageMutation.fetcher = (
  { workspace_id, pdp_id, image_id }: DeletePdpImageMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await deletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDelete({
      path: { workspace_id, pdp_id, image_id },
      throwOnError: true,
    });
    return data;
  };
};
